export default function navigate(path){
    window.open(path, "_self");
}